<div class="website-builder-container">
  <!-- Top Menu Bar - Full Width Header -->
  <div class="top-menu-bar">
    <div class="left-section">
      <div class="logo-section">
        <div class="logo">
          <img src="assets/122.png" alt="Logo" class="logo-image" />
        </div>
      </div>

      <div class="title-section">
        <h1 class="main-title">Carwash Website Builder</h1>
        <p class="last-saved">Last saved: {{ websiteData.lastSaved }}</p>
      </div>

      <div class="draft-tag" [class.published]="isWebsitePublished && !isPublishStatusLoading">
        <span>{{ websiteStatusLabel }}</span>
      </div>
    </div>

    <!-- Center Section - Device Switcher -->
    <div class="center-section">
      <div class="device-switcher">
        <button
          class="device-btn"
          [class.active]="currentDevice === 'desktop'"
          (click)="onDeviceChange('desktop')"
          [matTooltip]="'Desktop View'"
          matTooltipPosition="above"
        >
          <img [src]="ICONS.desktop" alt="Desktop" width="18" height="18" />
          <span>Desktop</span>
        </button>

        <button
          class="device-btn"
          [class.active]="currentDevice === 'tablet'"
          (click)="onDeviceChange('tablet')"
          [matTooltip]="'Tablet View'"
          matTooltipPosition="above"
        >
          <img [src]="ICONS.tablet" alt="Tablet" width="18" height="18" />
          <span>Tablet</span>
        </button>

        <button
          class="device-btn"
          [class.active]="currentDevice === 'mobile'"
          (click)="onDeviceChange('mobile')"
          [matTooltip]="'Mobile View'"
          matTooltipPosition="above"
        >
          <img [src]="ICONS.mobile" alt="Mobile" width="18" height="18" />
          <span>Mobile</span>
        </button>
      </div>
    </div>

    <!-- Right Section - Action Buttons -->
    <div class="right-section">
      <div class="action-buttons">
        <button
          class="action-btn"
          (click)="onSettingsClick()"
          [matTooltip]="'Settings'"
          matTooltipPosition="above"
        >
          <img [src]="ICONS.settings" alt="Settings" width="20" height="20" />
        </button>

        <button
          class="action-btn"
          (click)="onPreviewClick()"
          [matTooltip]="'Preview'"
          matTooltipPosition="above"
        >
          <img [src]="ICONS.preview" alt="Preview" width="20" height="20" />
        </button>

        <button
          class="publish-btn"
          [class.is-unpublish]="isWebsitePublished && !isPublishButtonLoading"
          [class.is-loading]="isPublishButtonLoading"
          (click)="onPublishClick()"
          [disabled]="isPublishButtonLoading"
          [matTooltip]="publishButtonTooltip"
          matTooltipPosition="above"
        >
          <span
            class="publish-btn-spinner"
            *ngIf="isPublishButtonLoading"
            aria-hidden="true"
          ></span>
          <span *ngIf="!isPublishButtonLoading">{{ publishButtonLabel }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Content Area with Sidebar and Main Content -->
  <div class="content-wrapper">
    <!-- Left Sidebar Navigation -->
    <div class="sidebar-navigation">
      <div class="sidebar-content">
        <!-- Main Navigation Items -->
        <div class="nav-items">
          <div
            class="nav-item"
            [class.active]="activeSidebarItem === 'pages'"
            [class.pages-active]="showPagesPanel"
            (click)="onSidebarItemClick('pages')"
            [matTooltip]="'Pages'"
            matTooltipPosition="right"
          >
            <div class="nav-icon">
              <img [src]="ICONS.pages" alt="Pages" width="14" height="18" />
            </div>
          </div>

          <div
            class="nav-item"
            [class.active]="activeSidebarItem === 'branding'"
            (click)="onSidebarItemClick('branding')"
            [matTooltip]="'Branding'"
            matTooltipPosition="right"
          >
            <div class="nav-icon">
              <img [src]="ICONS.branding" alt="Branding" width="18" height="18" />
            </div>
          </div>

          <div
            class="nav-item"
            [class.active]="activeSidebarItem === 'templates'"
            (click)="onSidebarItemClick('templates')"
            [matTooltip]="'Templates'"
            matTooltipPosition="right"
          >
            <div class="nav-icon">
              <img [src]="ICONS.templates" alt="Templates" width="16" height="16" />
            </div>
          </div>
        </div>

        <!-- Divider -->
        <div class="divider"></div>

        <!-- Bottom Actions -->
        <div class="bottom-actions">
          <div
            class="nav-item"
            (click)="onLogoutClick()"
            [matTooltip]="'Logout'"
            matTooltipPosition="right"
          >
            <div class="nav-icon">
              <img [src]="ICONS.logout" alt="Logout" width="18" height="16" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pages Panel -->
    <div class="pages-panel" [class.open]="showPagesPanel">
      <div class="pages-panel-header">
        <h3 class="pages-panel-title">Pages</h3>
        <button class="close-btn" (click)="closePagesPanel()">
          <img
            src="assets/images/website-builder/close-icon.svg"
            alt="Close"
            width="12"
            height="12"
          />
        </button>
      </div>

      <div class="pages-panel-tabs">
        <button
          class="tab-btn"
          [class.active]="activeTab === 'pages'"
          (click)="setActiveTab('pages')"
        >
          <img
            src="assets/images/website-builder/device-desktop.svg"
            alt="Pages"
            width="18"
            height="18"
          />
          <span>Pages</span>
        </button>
        <button
          class="tab-btn"
          [class.active]="activeTab === 'sections'"
          (click)="setActiveTab('sections')"
        >
          <img
            src="assets/images/website-builder/sections-icon.svg"
            alt="Sections"
            width="18"
            height="18"
          />
          <span>Sections</span>
        </button>
      </div>

      <!-- Pages List -->
      <div class="pages-list" *ngIf="activeTab === 'pages'">
        <app-toggle-card
          *ngFor="let page of pages; let i = index; trackBy: trackByIndex"
          [item]="page"
          [index]="i"
          (toggleChange)="onPageToggleChange($event)"
          (cardClick)="onPageClick($event)"
        >
        </app-toggle-card>
      </div>

      <!-- Sections List -->
      <div class="sections-list" *ngIf="activeTab === 'sections'">
        <app-toggle-card
          *ngFor="let section of sections; let i = index; trackBy: trackByIndex"
          [item]="section"
          [index]="i"
          (toggleChange)="onSectionToggleChange($event)"
        >
        </app-toggle-card>
      </div>
    </div>

    <!-- Branding Panel -->
    <div class="branding-panel" [class.open]="showBrandingPanel">
      <app-branding-panel
        [brandingData]="brandingData"
        (brandingChange)="onBrandingChange($event)"
        (setUpLater)="onSetUpLater()"
        (applyBranding)="onApplyBranding($event)"
        (instantUpdate)="onInstantBrandingUpdate($event)"
        (close)="closeBrandingPanel()"
      >
      </app-branding-panel>
    </div>

    <!-- Templates Panel -->
    <div class="templates-panel" [class.open]="showTemplatesPanel">
      <app-templates-panel
        [templates]="templates"
        [loading]="templatesLoading"
        [error]="templatesError"
        (templateSelect)="onTemplateSelect($event)"
        (templatePreview)="onTemplatePreview($event)"
        (close)="closeTemplatesPanel()"
      >
      </app-templates-panel>
    </div>

    <!-- Hero Panel (Hero Section) - Shared for all templates -->
    <div class="hero-panel" [class.open]="showHeroPanel">
      <app-minimal-hero-panel
        [headingColor]="headingColor"
        [paragraphColor]="paragraphColor"
        [primaryColor]="primaryColor"
        [headingFont]="headingFont"
        [bodyFont]="bodyFont"
        [data]="heroPanelData"
        (close)="closeHeroPanel()"
        (save)="onHeroPanelSave($event)"
        (valueChange)="onHeroPanelChange($event)"
      >
      </app-minimal-hero-panel>
    </div>

    <!-- Info Panel (Info/Welcome Section) - Shared for all templates -->
    <div class="info-panel" [class.open]="showInfoPanel">
      <app-minimal-info-panel
        [data]="infoPanelData"
        [headingColor]="headingColor"
        [paragraphColor]="paragraphColor"
        [primaryColor]="primaryColor"
        [headingFont]="headingFont"
        [bodyFont]="bodyFont"
        (close)="closeInfoPanel()"
        (save)="onInfoPanelSave($event)"
        (valueChange)="onInfoPanelChange($event)"
      >
      </app-minimal-info-panel>
    </div>

    <!-- Wash Packages Panel - Shared for all templates -->
    <div class="wash-packages-panel-container" [class.open]="showWashPackagesPanel">
      <app-wash-packages-panel
        [data]="washPackagesPanelData"
        (close)="closeWashPackagesPanel()"
        (save)="onWashPackagesSave($event)"
        (dataChange)="onWashPackagesChange($event)"
      >
      </app-wash-packages-panel>
    </div>

    <!-- Express Details Panel - Shared for all templates -->
    <div class="express-details-panel-container" [class.open]="showExpressDetailsPanel">
      <app-express-details-panel
        [data]="expressDetailsPanelData"
        (close)="closeExpressDetailsPanel()"
        (save)="onExpressDetailsSave($event)"
        (dataChange)="onExpressDetailsChange($event)"
      >
      </app-express-details-panel>
    </div>

    <!-- Coupons Panel - Shared for all templates -->
    <div class="coupons-panel-container" [class.open]="showCouponsPanel">
      <app-coupons-panel
        [data]="couponsPanelData"
        (close)="closeCouponsPanel()"
        (save)="onCouponsSave($event)"
        (dataChange)="onCouponsChange($event)"
      >
      </app-coupons-panel>
    </div>

    <!-- Fleets Panel - Shared for all templates -->
    <div class="fleets-panel-container" [class.open]="showFleetsPanel">
      <app-fleets-panel
        [data]="fleetsPanelData"
        (close)="closeFleetsPanel()"
        (save)="onFleetsSave($event)"
        (dataChange)="onFleetsChange($event)"
      >
      </app-fleets-panel>
    </div>

    <!-- Testimonials Panel - Shared for all templates -->
    <div class="testimonials-panel" [class.open]="showTestimonialsPanel">
      <app-minimal-testimonials-panel
        [data]="testimonialsData"
        (dataChange)="onTestimonialsChange($event)"
        (closePanel)="closeAllPanels()"
      >
      </app-minimal-testimonials-panel>
    </div>

    <!-- Booking Panel - Shared for all templates -->
    <div class="booking-panel-container" [class.open]="showBookingPanel">
      <app-minimal-booking-panel
        [data]="bookingData"
        (dataChange)="onBookingChange($event)"
        (closePanel)="closeAllPanels()"
      >
      </app-minimal-booking-panel>
    </div>

    <!-- Contact Panel - Shared for all templates -->
    <div class="contact-panel-container" [class.open]="showContactPanel">
      <app-minimal-contact-panel
        [data]="contactData"
        [headingColor]="headingColor"
        [paragraphColor]="paragraphColor"
        [primaryColor]="primaryColor"
        [headingFont]="headingFont"
        [bodyFont]="bodyFont"
        (dataChange)="onContactChange($event)"
        (closePanel)="closeAllPanels()"
      >
      </app-minimal-contact-panel>
    </div>

    <!-- Header Panel -->
    <div class="header-panel-container" [class.open]="showHeaderPanel">
      <app-header-panel
        [data]="headerData"
        [pages]="getPagesForNavigation()"
        (dataChange)="onHeaderChange($event)"
        (closePanel)="closeAllPanels()"
      >
      </app-header-panel>
    </div>

    <!-- Footer Panel -->
    <div class="footer-panel-container" [class.open]="showFooterPanel">
      <app-footer-panel
        [data]="footerData"
        [pages]="$any(pages)"
        (dataChange)="onFooterChange($event)"
        (closePanel)="closeAllPanels()"
      >
      </app-footer-panel>
    </div>

    <!-- Main Content Area -->
    <div
      class="main-content"
      [class.pages-panel-open]="showPagesPanel"
      [class.branding-panel-open]="showBrandingPanel"
      [class.templates-panel-open]="showTemplatesPanel"
      [class.hero-panel-open]="showHeroPanel"
      [class.info-panel-open]="showInfoPanel"
      [class.testimonials-panel-open]="showTestimonialsPanel"
      [class.booking-panel-open]="showBookingPanel"
      [class.contact-panel-open]="showContactPanel"
      [class.header-panel-open]="showHeaderPanel"
      [class.footer-panel-open]="showFooterPanel"
      [class.wash-packages-panel-open]="showWashPackagesPanel"
      [class.express-details-panel-open]="showExpressDetailsPanel"
      [class.coupons-panel-open]="showCouponsPanel"
      [class.fleets-panel-open]="showFleetsPanel"
    >
      <!-- Main Canvas Area -->
      <div class="canvas-container">
        <!-- Website Preview Header -->
        <div
          class="preview-header"
          [class.device-desktop]="currentDevice === 'desktop'"
          [class.device-tablet]="currentDevice === 'tablet'"
          [class.device-mobile]="currentDevice === 'mobile'"
          [style.width.px]="getBaseWidth() * (zoomLevel / 100)"
        >
          <div class="preview-info">
            <div class="device-info">
              <img
                [src]="
                  currentDevice === 'desktop'
                    ? ICONS.desktop
                    : currentDevice === 'tablet'
                      ? ICONS.tablet
                      : ICONS.mobile
                "
                [alt]="currentDevice"
                width="18"
                height="18"
              />
              <span class="page-title">{{ websiteData.title }}</span>
            </div>
            <div class="dimensions">{{ websiteData.dimensions }}</div>
          </div>
        </div>

        <!-- Website Preview -->
        <div
          class="website-preview"
          [class.device-desktop]="currentDevice === 'desktop'"
          [class.device-tablet]="currentDevice === 'tablet'"
          [class.device-mobile]="currentDevice === 'mobile'"
          [style.transform]="'scale(' + zoomLevel / 100 + ')'"
          [style.transform-origin]="'top center'"
          [style.width.px]="getBaseWidth()"
        >
          <!-- Loading Spinner -->
          <div *ngIf="loading" class="preview-loading-container">
            <div class="preview-loading-spinner"></div>
            <p>Loading website preview...</p>
          </div>

          <!-- Minimal Website Template (e52c4811-f3f9-4f64-8cdb-520396dbeac7) -->
          <ng-container
            *ngIf="
              !loading &&
              (currentTemplateId === 'e52c4811-f3f9-4f64-8cdb-520396dbeac7' || !currentTemplateId)
            "
          >
            <!-- Home Page Preview -->
            <app-home-page-preview
              *ngIf="currentPageType === 'home'"
              [elements]="websiteElements"
              [sectionVisibility]="getSectionVisibilityMap()"
              [pages]="pages"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              [pageData]="currentJsonData"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-home-page-preview>

            <!-- Express Wash Packages Preview -->
            <app-express-wash-packages-preview
              *ngIf="currentPageType === 'express-wash-packages'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-express-wash-packages-preview>

            <!-- Express Auto Details Preview -->
            <app-express-auto-details-preview
              *ngIf="currentPageType && currentPageType.includes('express-auto-details')"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-express-auto-details-preview>

            <!-- Fleet Management Preview -->
            <app-fleet-management-preview
              *ngIf="currentPageType === 'fleet-management'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-fleet-management-preview>

            <!-- Coupons Preview -->
            <app-coupons-preview
              *ngIf="currentPageType === 'car-wash-coupons--way'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-coupons-preview>
          </ng-container>

          <!-- Dark Theme Template (808371ee-5130-4e24-8334-69646e403de4) -->
          <ng-container
            *ngIf="!loading && currentTemplateId === '808371ee-5130-4e24-8334-69646e403de4'"
          >
            <!-- Home Page Preview -->
            <app-dark-home-page-preview
              *ngIf="currentPageType === 'home'"
              [elements]="websiteElements"
              [sectionVisibility]="getSectionVisibilityMap()"
              [pages]="pages"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              [pageData]="currentJsonData"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-dark-home-page-preview>

            <!-- Express Wash Packages Preview -->
            <app-dark-express-wash-packages-preview
              *ngIf="currentPageType === 'express-wash-packages'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-dark-express-wash-packages-preview>

            <!-- Express Auto Details Preview -->
            <app-dark-express-auto-details-preview
              *ngIf="currentPageType && currentPageType.includes('express-auto-details')"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-dark-express-auto-details-preview>

            <!-- Fleet Management Preview -->
            <app-dark-fleet-management-preview
              *ngIf="currentPageType === 'fleet-management'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-dark-fleet-management-preview>

            <!-- Coupons Preview -->
            <app-dark-coupons-preview
              *ngIf="currentPageType === 'car-wash-coupons--way'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-dark-coupons-preview>
          </ng-container>

          <!-- Modern Theme Template (71715e65-dc16-49b6-ac7a-0bb75fee6a2e) -->
          <ng-container
            *ngIf="!loading && currentTemplateId === '71715e65-dc16-49b6-ac7a-0bb75fee6a2e'"
          >
            <!-- Home Page Preview -->
            <app-modern-home-page-preview
              *ngIf="currentPageType === 'home'"
              [elements]="websiteElements"
              [sectionVisibility]="getSectionVisibilityMap()"
              [pages]="pages"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              [pageData]="currentJsonData"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-modern-home-page-preview>

            <!-- Express Wash Packages Preview -->
            <app-modern-express-wash-packages-preview
              *ngIf="currentPageType === 'express-wash-packages'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-modern-express-wash-packages-preview>

            <!-- Express Auto Details Preview -->
            <app-modern-express-auto-details-preview
              *ngIf="currentPageType && currentPageType.includes('express-auto-details')"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-modern-express-auto-details-preview>

            <!-- Fleet Management Preview -->
            <app-modern-fleet-management-preview
              *ngIf="currentPageType === 'fleet-management'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-modern-fleet-management-preview>

            <!-- Coupons Preview -->
            <app-modern-coupons-preview
              *ngIf="currentPageType === 'car-wash-coupons--way'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-modern-coupons-preview>
          </ng-container>

          <!-- Champs Theme Template (c97e1e03-b1c5-47fb-b753-27cd541cfdf8) -->
          <ng-container
            *ngIf="!loading && currentTemplateId === 'c97e1e03-b1c5-47fb-b753-27cd541cfdf8'"
          >
            <!-- Home Page Preview -->
            <app-champs-home-page-preview
              *ngIf="currentPageType === 'home'"
              [elements]="websiteElements"
              [sectionVisibility]="getSectionVisibilityMap()"
              [pages]="pages"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              [pageData]="currentJsonData"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-champs-home-page-preview>

            <!-- Express Wash Packages Preview -->
            <app-champs-express-wash-packages-preview
              *ngIf="currentPageType === 'express-wash-packages'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-champs-express-wash-packages-preview>

            <!-- Express Auto Details Preview -->
            <app-champs-express-auto-details-preview
              *ngIf="currentPageType && currentPageType.includes('express-auto-details')"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-champs-express-auto-details-preview>

            <!-- Memberships Preview -->
            <app-champs-memberships-preview
              *ngIf="currentPageType === 'memberships'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-champs-memberships-preview>

            <!-- Fleet Management Preview -->
            <app-champs-fleet-management-preview
              *ngIf="currentPageType === 'fleet-management'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-champs-fleet-management-preview>

            <!-- Coupons Preview -->
            <app-champs-coupons-preview
              *ngIf="currentPageType === 'car-wash-coupons--way'"
              [pageData]="currentJsonData"
              [pages]="pages"
              [currentPageType]="currentPageType"
              [sectionVisibility]="getSectionVisibilityMap()"
              [elements]="websiteElements"
              [deviceType]="currentDevice"
              [primaryColor]="primaryColor"
              [headingColor]="headingColor"
              [paragraphColor]="paragraphColor"
              [headingFont]="headingFont"
              [bodyFont]="bodyFont"
              (elementSelect)="onWebsiteElementSelect($event)"
              (navigationClick)="onNavigationClick($event)"
            >
            </app-champs-coupons-preview>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Right Toolbar -->
    <div
      class="right-toolbar"
      [class.hero-panel-open]="showHeroPanel"
      [class.wash-packages-panel-open]="showWashPackagesPanel"
      [class.express-details-panel-open]="showExpressDetailsPanel"
      [class.coupons-panel-open]="showCouponsPanel"
      [class.fleets-panel-open]="showFleetsPanel"
      [class.info-panel-open]="showInfoPanel"
      [class.testimonials-panel-open]="showTestimonialsPanel"
      [class.booking-panel-open]="showBookingPanel"
      [class.contact-panel-open]="showContactPanel"
      [class.header-panel-open]="showHeaderPanel"
      [class.footer-panel-open]="showFooterPanel"
    >
      <div class="tool-buttons">
        <button
          class="tool-btn"
          [class.disabled]="!canUndo"
          (click)="
            onToolbarAction({ id: 'undo', icon: ICONS.undo, label: 'Undo', disabled: !canUndo })
          "
          [matTooltip]="'Undo'"
          matTooltipPosition="left"
        >
          <img [src]="ICONS.undo" alt="Undo" width="24" height="24" />
        </button>

        <button
          class="tool-btn"
          [class.disabled]="!canRedo"
          (click)="
            onToolbarAction({ id: 'redo', icon: ICONS.redo, label: 'Redo', disabled: !canRedo })
          "
          [matTooltip]="'Redo'"
          matTooltipPosition="left"
        >
          <img [src]="ICONS.redo" alt="Redo" width="24" height="24" />
        </button>

        <button
          class="tool-btn"
          (click)="onToolbarAction({ id: 'refresh', icon: ICONS.refresh, label: 'Refresh' })"
          [matTooltip]="'Refresh'"
          matTooltipPosition="left"
        >
          <img [src]="ICONS.refresh" alt="Refresh" width="24" height="24" />
        </button>

        <button
          class="tool-btn"
          (click)="onToolbarAction({ id: 'maximize', icon: ICONS.maximize, label: 'Maximize' })"
          [matTooltip]="'Zoom to Fit'"
          matTooltipPosition="left"
        >
          <img [src]="ICONS.maximize" alt="Maximize" width="24" height="24" />
        </button>

        <button
          class="tool-btn"
          (click)="onToolbarAction({ id: 'zoom-out', icon: ICONS.zoomOut, label: 'Zoom Out' })"
          [matTooltip]="'Zoom Out'"
          matTooltipPosition="left"
        >
          <img [src]="ICONS.zoomOut" alt="Zoom Out" width="24" height="24" />
        </button>

        <button
          class="tool-btn"
          (click)="onToolbarAction({ id: 'zoom-in', icon: ICONS.zoomIn, label: 'Zoom In' })"
          [matTooltip]="'Zoom In'"
          matTooltipPosition="left"
        >
          <img [src]="ICONS.zoomIn" alt="Zoom In" width="24" height="24" />
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Website Settings Page -->
<app-website-settings
  *ngIf="showSettingsPage"
  [websiteData]="websiteData"
  [websiteId]="websiteId"
  [websitePages]="pages"
  [initialActiveSidebarItem]="initialSettingsSidebarItem"
  (close)="onSettingsClose()"
  (save)="onSettingsSave($event)"
  (unpublish)="onWebsiteUnpublish()"
  (domainConfirmed)="onDomainConfirmed()"
>
</app-website-settings>

<!-- Replace Template Confirmation Modal -->
<app-replace-template-modal
  [isOpen]="showReplaceTemplateModal"
  [isLoading]="isReplacingTemplate"
  (close)="onReplaceTemplateCancel()"
  (confirm)="onReplaceTemplateConfirm()"
>
</app-replace-template-modal>
